import React from 'react';
import GqlQueryWrapper from '../GqlQueryWrapper/GqlQueryWrapper';
import { tipsFunds } from '../../utils/fund-info';
import TablePreRender from '../Table/Table.prerender';
import { INFLATION_VOLATILITY_QUERY } from './query';

const benchmarkTicker = 'PRTIX';

export const inflationVolatilityUtil = (gqlResponse) => {
    if (!(gqlResponse && gqlResponse.mutualFund)) return null;

    const {
        yield30DayStandard: benchmarkYield30DayStandard,
        unsubsidizedThirtyDaySECYield: benchmarkUnsubsidizedThirtyDaySECYield
    } = gqlResponse.mutualFund;

    const checkInflationVolatility = (
        fundYield,
        unsubsidizedFundYield,
        ticker
    ) => {
        // check if the fund's yields out perform the benchmark by 25%
        const isFundYieldVolatile =
            fundYield >= benchmarkYield30DayStandard * 1.25 &&
            tipsFunds.includes(ticker);

        const isUnsubsidizedFundYieldVolatile =
            unsubsidizedFundYield >=
                benchmarkUnsubsidizedThirtyDaySECYield * 1.25 &&
            tipsFunds.includes(ticker);

        return !isFundYieldVolatile
            ? isUnsubsidizedFundYieldVolatile
            : isFundYieldVolatile;
    };

    return { checkInflationVolatility };
};

const addPropsToChildren = (children, data) =>
    React.Children.map(children, (child) => React.cloneElement(child, data));

const InflationVolatilityWrapper = ({ children }) => (
    <GqlQueryWrapper
        query={INFLATION_VOLATILITY_QUERY}
        variables={{ benchmarkTicker }}
        dataFunc={inflationVolatilityUtil}
        placeholder={() => <TablePreRender />}
    >
        {({ data }) => (
            <React.Fragment>
                {addPropsToChildren(children, data)}
            </React.Fragment>
        )}
    </GqlQueryWrapper>
);

export default InflationVolatilityWrapper;
